<template>
	<div
		:class="[
			'asset-details-update-card-horizontal display-flex-md',
			{ 'asset-details-update-card-horizontal__card-fixed-width': !appStore.isMobile }
		]"
	>
		<BaseLink :link="updateLink" classes="display-flex-md">
			<div :class="['display-flex align-items-center-smo justify-content-space-between-smo py-100-smo']">
				<div
					:class="[
						'img-lazy-wrapper img-lazy-wrapper-transparent mr-100-smo',
						{ 'order-1': props.positionImageRight },
						!appStore.isMobile
							? 'asset-details-update-card-horizontal__img-fixed-width'
							: 'asset-details-update-card-horizontal__mobile-img-wrapper'
					]"
				>
					<img
						:class="[
							'asset-details-update-card-horizontal__img',
							!appStore.isMobile ? 'rounded-left' : 'rounded'
						]"
						:src="thumbnail"
						alt=""
						role="presentation"
					/>
				</div>
				<div
					class="px-100 py-50 px-150-md py-100-md display-flex flex-direction-column justify-content-space-between flex-1 dark"
					:class="[{ 'asset-details-update-card-horizontal__title': appStore.isMobile }]"
				>
					<div>
						<h4 class="body-lg font-weight-bold my-25 line-clamp">{{ title }}</h4>
						<p v-if="!appStore.isMobile" class="body-md mt-50 mb-100 line-clamp">{{ subtitle }}</p>
					</div>
					<span
						:class="[
							'body-md font-weight-bold text-color-rust mb-25',
							{ 'text-align-right': !appStore.isMobile }
						]"
						>View update</span
					>
				</div>
			</div>
		</BaseLink>
	</div>
</template>
<script setup lang="ts">
import { AssetUpdateSanity } from 'types/assets';
import { computed } from 'vue';
import { Link } from 'types/layout';
import { useAppStore } from '@stores/app';

interface Props {
	update: AssetUpdateSanity;
	positionImageRight?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	positionImageRight: false
});

const appStore = useAppStore();

const updateLink: Link = {
	router: 'investor-update',
	params: {
		investorUpdateId: props.update.fundriseId
	}
};

const thumbnail = computed((): string => props.update.thumbnailUrl);

const title = computed((): string => props.update.title);

const subtitle = computed((): string => props.update.subtitle);
</script>
<style lang="scss" scoped>
@use '../../../styles/constants/colors.scss' as *;

.asset-details-update-card-horizontal {
	width: 100%;
	background: #fff;
	border-radius: 8px;
	border: 1px solid token('bg-tertiary');
	overflow: hidden;

	&__card-fixed-width {
		max-width: 816px;
		height: 250px;
	}

	&__img-fixed-width {
		min-width: 250px;
		max-width: 250px;
	}

	&__mobile-img-wrapper {
		width: 72px;
		height: 72px;
		object-fit: cover;
	}

	&__img {
		opacity: 1;
		object-fit: cover;
		overflow: none;
	}

	&__title {
		max-width: 75%;
	}
}

.line-clamp {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.rounded-left {
	border-radius: 2px 0 0 2px;
}
</style>
